import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { NumberFormat } from 'modules/Editor/components/SideMenuSettings/ChartSettings';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { DataLabelAdornment, DataLabelFormat } from '../DataTableChartCommon/ChartSettingsNumberFormat';

export const NumberFormatSettings = memo(() => {
  const { t } = useTranslation('editor_side_menu_settings', { useSuspense: false, keyPrefix: 'chartSettings' });

  return (
    <NumberFormat>
      <Tabs variant={'sub-menu'} isLazy>
        <TabList>
          <Tab>{t('controlledHeader.y1')}</Tab>
          <Tab>{t('controlledHeader.y2')}</Tab>
        </TabList>
        <TabPanels height={'max-content'}>
          <TabPanel>
            <DataLabelAdornment />
            <DataLabelFormat />
          </TabPanel>
          <TabPanel>
            <DataLabelAdornment axisName='y2Axis' />
            <DataLabelFormat axisName='y2Axis' />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </NumberFormat>
  );
});
NumberFormatSettings.displayName = 'ComboChartWidgetNumberFormatSettings';
